export default {
  label: {
    replierName: 'Atendente',
    rating: 'Evaluación',
    viewRating: 'Abrir evaluación',
    button: {
      view: 'Abrir publicación',
      apply: 'Aplicar filtros',
      clear: 'Limpiar filtros',
    },
    table: {
      header: {
        userName: 'Usuario',
        surveyScore: 'Evaluación',
        surveyComment: 'Comentario',
        replierName: 'Atendente',
        responseAt: 'Fecha de la evaluación',
        seeRating: 'Ver evaluación',
      },
    },
  },
  faq: {
    title: '¿Qué es?',
    description: 'Lista de notas y comentarios que cada usuario realizó dentro de la Encuesta de Satisfacción.',

    faq01: {
      title: '¿Cómo realizo el filtro de evaluaciones?',
      description: 'La posición de la estrella que se llenará al hacer clic será filtrada, por ejemplo, primera y tercera posición llenas: aparecerán solo evaluaciones de 1 y 3 estrellas.',
    },
    faq02: {
      title: '¿Es posible obtener la lista de evaluaciones de operadores específicos?',
      description: 'Sí, es posible realizar el filtro por usuario que listará todas las evaluaciones del respondente específico.',
    },
  },
};
